var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2063",
    "data-name": "Grupo 2063",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2007",
    "data-name": "Grupo 2007",
    transform: "translate(-139 -680)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(146 687)",
    fill: "#009ebe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1184",
    "data-name": "Caminho 1184",
    d: "M191.708,39.2H171.475a.674.674,0,0,0-.674.674V67.524a.675.675,0,0,0,.674.674h20.233a.675.675,0,0,0,.674-.674V39.873a.675.675,0,0,0-.674-.674ZM175.69,61.117h11.8a.674.674,0,0,1,0,1.349h-11.8a.674.674,0,0,1,0-1.349Zm-.674-3.709h0a.674.674,0,0,1,.674-.675h11.8a.674.674,0,0,1,0,1.349h-11.8a.674.674,0,0,1-.674-.674Zm12.477-3.035h-11.8a.674.674,0,1,1,0-1.349h11.8a.674.674,0,1,1,0,1.349Zm-2.866-8.767a.674.674,0,1,1,0,1.349h-2.36v2.36a.674.674,0,0,1-1.349,0v-2.36h-2.36a.674.674,0,1,1,0-1.349h2.36V43.245a.674.674,0,0,1,1.349,0v2.36Z",
    transform: "translate(-147.592 -20.199)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon_report.629f339d867c05baf3798fff092c3909.svg";
export { ForwardRef as ReactComponent };